export interface DossierAbandonFitterSuccess {
  type: 'success';
  abandonmentComment: string;
}

export interface DossierAbandonFitterCancel {
  type: 'cancel';
}

export type DossierAbandonFitterOutputData =
  | DossierAbandonFitterSuccess
  | DossierAbandonFitterCancel;
